import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Button, makeStyles } from "@fluentui/react-components";
import { FormattedMessage } from "react-intl";
import { Modal } from "../modal/Modal";

const useStyles = makeStyles({
  textField: {
    width: "100%"
  }
});

export function DeleteAssetDialog({ asset, open, onOpenChange, onDelete, title }) {
  const styles = useStyles();

  const handleDelete = useCallback(() => {
    onOpenChange(null, { open: false });
    onDelete({ id: asset.id });
  }, [onOpenChange, onDelete, asset]);

  const handleClose = () => {
    onOpenChange(null, { open: false });
  };

  const actions = (
    <>
      <Button appearance="outline" onClick={handleClose}>
        <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
      </Button>
      <Button appearance="primary" onClick={handleDelete}>
        <FormattedMessage id="asset-editor.submit-button.delete" defaultMessage="Delete" />
      </Button>
    </>
  );

  return (
    <Modal title={title} open={open} onOpenChange={onOpenChange} onClose={handleClose} actions={actions}>
      <div className={styles.textField}>
        <FormattedMessage
          id="asset-editor.delete-confirmation"
          defaultMessage="Are you sure you want to delete the asset {assetTitle}?"
          values={{ assetTitle: asset.title }}
        />
      </div>
    </Modal>
  );
}

DeleteAssetDialog.propTypes = {
  asset: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
